module.exports = __webpack_public_path__ + "static/img/coupon.999a155c.png";